export const getDatabaseMultiplier = (processType: string): number | null => {
  const type = processType.toLowerCase();

  if (["postgresql", "mysql", "mongodb"].includes(type)) {
    return 3;
  }

  if (["elasticsearch", "influxdb", "rabbitmq"].includes(type)) {
    return 2;
  }

  return null;
};

export const getDatabaseLabel = (processType: string): string => {
  const type = processType.toLowerCase();

  const displayNames: Record<string, string> = {
    postgresql: "PostgreSQL",
    mysql: "MySQL",
    mongodb: "MongoDB",
    elasticsearch: "Elasticsearch",
    influxdb: "InfluxDB",
    rabbitmq: "RabbitMQ",
  };

  return displayNames[type] || processType;
};
